import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/site";
import { STATIC_REVIEWS } from "@/lib/staticData";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews")
      .then((r) => setReviews(r.data))
      .catch(() => setReviews(STATIC_REVIEWS));
  }, []);

  return (
    <div data-testid="reviews-page">
      <PageHero eyebrow="TESTIMONIALS" title="What Our Families Say" subtitle="Real stories from parents, students and alumni who call Royal English home." />

      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 4) * 0.08 }}
              data-testid={`review-${i}`}
              className="bg-[#f7f7f7] p-8 rounded-3xl border border-gray-100 relative"
            >
              <Quote className="text-gold/30 absolute top-5 right-5" size={48} />
              <div className="flex gap-1 text-gold mb-4">
                {Array.from({ length: r.rating || 5 }).map((_, j) => <Star key={j} size={18} fill="currentColor" />)}
              </div>
              <p className="text-gray-700 leading-relaxed italic text-lg">"{r.message}"</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-royal text-white font-bold flex items-center justify-center text-lg">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-bold text-royal">{r.name}</p>
                  <p className="text-xs text-gray-500">{r.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
          {reviews.length === 0 && (
            <p className="text-center text-gray-500 col-span-2 py-10">No reviews yet.</p>
          )}
        </div>
      </section>
    </div>
  );
}
